import { styled } from '@glitz/react';

export const overflowYDecorator = styled({
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
});
